import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";
  import BuilderEstimatorSummaryDesktop from "./BuilderEstimatorSummaryDesktop.vue";
  import BuilderEstimatorSummaryMobile from "./BuilderEstimatorSummaryMobile.vue";
  import type { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
  import { FormSummaryType } from "@/enums/FormSummaryType";
  import { BuilderEstimatorMapper } from "@/mappers/builderEstimatorMapper";
  import store from "@/store";
  import { ref } from "vue";
  import { useToast } from "vue-toastification";
  import { SummaryUserSelectionFormData } from "@/types/BuilderEstimatorMapper";
  import { AxiosResponse } from "axios";
  import { openBookConsultationPopup } from "@/helpers/builder/openBookConsultationPopup";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummary',
  props: {
    builderLogo: {},
    formData: {},
    totalPrice: {}
  },
  emits: ["select-prev", "is-loading"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const showSuccessMessage = ref<boolean>(false);
  const toast = useToast();
  const isLoading = ref<boolean>(false);
  const { isDesktop } = useIsDesktop(980);

  const props = __props;

  const emit = __emit;

  const onSelectPrev = () => {
    emit("select-prev");
  };

  const openCalendlyConsultationPopup = (
    data: SummaryUserSelectionFormData
  ) => {
    if (data.formSummaryType === FormSummaryType.CONSULTATION) {
      openBookConsultationPopup();
    }
  };

  const onFormSubmit = async (data: SummaryUserSelectionFormData) => {
    try {
      isLoading.value = true;
      const storeAction = "builder/sendUserBuilderEstimatorSummaryEmail";

      const payload = {
        ...BuilderEstimatorMapper.fromUserSelectedOptionsToSendEmails(data),
        buildEstimationPdfDto:
          BuilderEstimatorMapper.fromUserSelectedOptionsToCreateFreeDesign(
            data
          ),
      };

      const res = await store.dispatch(storeAction, payload);

      if (!res?.data) {
        throw new Error("No response data received");
      }

      showSuccessMessage.value = true;
      openCalendlyConsultationPopup(data);
    } catch (error) {
      showSuccessMessage.value = false;
      toast.error("An error occurred while submitting the form");
    } finally {
      isLoading.value = false;
    }
  };

const __returned__ = { showSuccessMessage, toast, isLoading, isDesktop, props, emit, onSelectPrev, openCalendlyConsultationPopup, onFormSubmit, get useIsDesktop() { return useIsDesktop }, BuilderEstimatorSummaryDesktop, BuilderEstimatorSummaryMobile, get FormSummaryType() { return FormSummaryType }, get BuilderEstimatorMapper() { return BuilderEstimatorMapper }, get store() { return store }, ref, get useToast() { return useToast }, get SummaryUserSelectionFormData() { return SummaryUserSelectionFormData }, get AxiosResponse() { return AxiosResponse }, get openBookConsultationPopup() { return openBookConsultationPopup } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})